export default __webpack_public_path__ + "static/media/offline.36cee690.svg";